const CommHelpStaticPageDisplayText = {
    programOverview: {
        english: 'PROGRAM OVERVIEW: Lincoln Financial Customer Alerts',
        spanish: 'RESUMEN DEL PROGRAMA: Alertas de clientes de Lincoln Financial',
    },
    programOverviewDescription: {
        english: 'This SMS service allows you to receive text alerts when there is a status change on your claim or absence, or when Lincoln Financial has issued a payment. You may also opt-in to receive text notifications about your return-to-work status.',
        spanish: 'Este servicio de SMS le permite recibir alertas por mensaje de texto cuando haya un cambio en el estado de su reclamo o ausencia, o cuando Lincoln Financial emita un pago. También puede optar por recibir notificaciones por mensaje de texto sobre su estado de reincorporación al trabajo.',
    },
    termsAndConditions: {
        english: 'TERMS AND CONDITIONS FOR THE Lincoln Financial Customer Alerts',
        spanish: 'TÉRMINOS Y CONDICIONES PARA LAS ALERTAS DE CLIENTES DE Lincoln Financial',
    },
    mobileOperators: {
        english: 'The mobile operators participating in this campaign are AT&T, Verizon Wireless, Sprint, T-Mobile©, Boost Mobile, Cricket, Virgin Mobile USA, MedivoPCS, U.S. Cellular©, Ntelos, Cellular South, Cincinnati Bell, Centennial, Bluegrass, Appalachian Wireless, Revol, Illinois Valley, United Wireless, Inland Cellular, West Cendival Cellular, ECIT, Immix, Nex-Tech, Pocket Com USA, Pioneer Wireless USA, Simmerty US, Union Wireless, Cellcom.',
        spanish: 'Los operadores móviles que participan en esta campaña son AT&T, Verizon Wireless, Sprint, T-Mobile©, Boost Mobile, Cricket, Virgin Mobile USA, MedivoPCS, U.S. Cellular©, Ntelos, Cellular South, Cincinnati Bell, Centennial, Bluegrass, Appalachian Wireless, Revol, Illinois Valley, United Wireless, Inland Cellular, West Cendival Cellular, ECIT, Immix, Nex-Tech, Pocket Com USA, Pioneer Wireless USA, Simmerty US, Union Wireless, Cellcom. \n',
    },
    listEntry1: {
        english: 'For help text "HELP" to {smsFromNumber}. For questions about your claim or leave, please contact your case manager. For technical assistance, call 1-800-431-2958. ',
        spanish: 'Para obtener ayuda, envíe "HELP" a {smsFromNumber}. Si tiene preguntas sobre su reclamo o licencia, comuníquese con su administrador de casos. Para asistencia técnica, llame al 1-800-431-2958.',
    },
    listEntry2: {
        english: 'To unsubscribe, text "STOP" to {smsFromNumber} at any time.',
        spanish: 'Para cancelar la suscripción, envíe "STOP" a {smsFromNumber} en cualquier momento.',
    },
    listEntry3: {
        english: 'Message and Data rates may apply.',
        spanish: 'Se pueden aplicar tarifas por mensajes y datos.',
    },
    listEntry4: {
        english: 'Msg Frequency based on user activity.',
        spanish: 'Frecuencia de mensajes basada en la actividad del usuario.',
    },
    listEntry5: {
        english: 'SMS text messages are intended to be a best effort communication and represent just one component of Lincoln Financial communication systems. Carriers are not liable for delayed or undelivered messages.',
        spanish: 'Los mensajes de texto SMS están destinados a ser el mejor esfuerzo de comunicación y representan solo un componente de los sistemas de comunicación del Lincoln Financial. Los operadores no son responsables de mensajes demorados o no entregados.',
    },
    listEntry6: {
        english: 'SMS text message notifications may be delayed or not received during regional emergencies or other periods of high messaging traffic.',
        spanish: 'Las notificaciones de mensajes de texto SMS pueden redivasarse o no recibirse durante emergencias regionales u odivos períodos de alto diváfico de mensajes.',
    },
    listEntry7: {
        english: 'Third parties can send SMS text messages disguised as alerts from Lincoln Financial and therefore you are urged to independently  verify the authenticity of any message that you receive.',
        spanish: 'Los terceros pueden enviar mensajes de texto SMS disfrazados como alertas de Lincoln Financial y, por lo tanto, se recomienda que verifique independientemente la autenticidad de cualquier mensaje que reciba.',
    },
    listEntry8: {
        english: 'SMS text message order delivery is not always predictive.',
        spanish: 'La endivega de pedidos de mensajes de texto SMS no siempre es predecible.',
    },
    listEntry9: {
        english: 'SMS text message notifications from Lincoln Financial will be presented on your mobile device in the same manner as any other SMS text messages.',
        spanish: 'Las notificaciones de mensajes de texto SMS de Lincoln Financial se presentarán en su dispositivo móvil de la misma manera que cualquier odivo mensaje de texto SMS.',
    },
    listEntry10: {
        english: 'MMS (Multimedia Messaging Service) messages may be sent by this service to deliver relevant images.',
        spanish: 'Este servicio puede enviar mensajes MMS (Servicio de mensajería multimedia) para endivegar imágenes relevantes.',
    },
    listEntry11: {
        english: 'If your phone does not support MMS, the user will receive SMS instead.',
        spanish: 'Si su teléfono no es compatible con MMS, el usuario recibirá SMS en su lugar.',
    },
    listEntry12: {
        english: 'See our ',
        spanish: 'Consulte nuestra ',
    },
    listEntry12Link: {
        english: 'Privacy notice',
        spanish: 'Aviso de privacidad',
    },
    listEntry13: {
        english: 'Messages are limited to those described above. Opting into this program does not opt you in to any other messages from Lincoln or our partners.',
        spanish: 'Los mensajes se limitan a los descritos anteriormente. Al suscribirse a este programa, no recibirá ningún otro mensaje de Lincoln ni de nuestros socios.',
    },
};
export default CommHelpStaticPageDisplayText;
